var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"d-flex flex-column align-items-center justify-content-around"},[_c('h3',[_c('strong',[_vm._v("Address")])]),_c('p',[_vm._v("Next to the Inn of the Prancing Pony")]),_c('p',[_vm._v("Bree, Shire")])])])
}]

export { render, staticRenderFns }